import React from 'react';
import {Divider} from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, author, cata, brief}) => (
<div style={{
    height: '102px',
    position: 'relative',
}}>
    <Link to={`/book/detail/${novel_id}`}>
        <img alt='' src={pic} style={{
            height: '102px',
            width: '80px',
            float: 'left',
        }}/>
        <div style={{
            position: 'relative',
            marginLeft: '90px',
        }}>
            <div style={{
                fontSize: '16px',
                lineHeight: '22px',
                color: '#333333',
            }}>
                <LinesEllipsis maxLine={1} text={name}/>
            </div>
            <div style={{
                marginTop: '4px',
                fontSize: '12px',
                lineHeight: '17px',
                color: '#999999',
            }}>
            {cata}{author && <span><Divider type="vertical" />{author}</span>}
            </div>
            <div style={{
                marginTop: '10px',
                fontSize: '14px',
                lineHeight: '20px',
                color: '#999999',
            }}>
				<LinesEllipsis text={brief} maxLine={2} />
            </div>
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_3.js